import { render, staticRenderFns } from "./AllApprovalStatus.vue?vue&type=template&id=6c731359&scoped=true"
var script = {}
import style0 from "./AllApprovalStatus.vue?vue&type=style&index=0&id=6c731359&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c731359",
  null
  
)

export default component.exports